import dateFormatType from '@/constants/dateFormatType';
import brgI18n from '@/locales';
import { convertCase, currency, validateTextWithHypen, } from '@/utils';
import { format } from 'date-fns';
export class WorkerBaromoneyHistory {
    _workerBaromoneyHistory;
    constructor(workerBaromoneyHistory) {
        this._workerBaromoneyHistory = workerBaromoneyHistory;
    }
    /** 일시 */
    get formattedCreatedAt() {
        const createdAt = new Date(this._workerBaromoneyHistory.createdAt);
        const formattedCreatedAt = format(createdAt, dateFormatType.FULL_DATE);
        return validateTextWithHypen(formattedCreatedAt);
    }
    /** 허브명 */
    get formattedHubName() {
        return validateTextWithHypen(this._workerBaromoneyHistory.hubName);
    }
    /** 고용형태 */
    get formattedEmployeeType() {
        const employeeType = convertCase(this._workerBaromoneyHistory.employeeType, 'enum', 'snake');
        const employeeTypeText = brgI18n.global.t(`resource.worker.employee_type_option.${employeeType}`);
        return validateTextWithHypen(employeeTypeText);
    }
    /** 보수지급방식 */
    get formattedSalaryType() {
        const salaryType = convertCase(this._workerBaromoneyHistory.salaryType, 'enum', 'snake');
        const salaryTypeText = brgI18n.global.t(`resource.worker.salary_type_option.${salaryType}`);
        return validateTextWithHypen(salaryTypeText);
    }
    /** 라이더사번 */
    get formattedHubEmployeeNumber() {
        const { hubEmployeeNumber } = this._workerBaromoneyHistory;
        return validateTextWithHypen(hubEmployeeNumber);
    }
    /** 라이더코드 */
    get formattedWorkerCode() {
        const { workerCode } = this._workerBaromoneyHistory;
        return validateTextWithHypen(workerCode);
    }
    /** 라이더명 */
    get formattedWorkerName() {
        const { workerName } = this._workerBaromoneyHistory;
        return validateTextWithHypen(workerName);
    }
    /** 항목 */
    get formattedContent() {
        const { content } = this._workerBaromoneyHistory;
        return validateTextWithHypen(content);
    }
    /** 금액 */
    get formattedTransactionBaromoney() {
        const { transactionBaromoney } = this._workerBaromoneyHistory;
        return validateTextWithHypen(currency(transactionBaromoney));
    }
    /** 라이더 바로머니 잔액 */
    get formattedBalanceBaromoney() {
        const { balanceBaromoney } = this._workerBaromoneyHistory;
        return validateTextWithHypen(currency(balanceBaromoney));
    }
    /** 접수번호 */
    get formattedOrderId() {
        const { orderId } = this._workerBaromoneyHistory;
        return validateTextWithHypen(orderId);
    }
    /** 처리자 */
    get formattedCreatedBy() {
        const { createdBy } = this._workerBaromoneyHistory;
        return validateTextWithHypen(createdBy);
    }
}
